import React from 'react';
import Header from '../../components/Header/Header';
import Hero1 from '../../components/Hero1/Hero1';
import AboutUs from '../../components/AboutUs/AboutUs';
// import Materials from '../../components/Materials/Materials';
import Footer from '../../components/Footer/Footer';

const Page1 = () => {
  return (
    <div>
      <Header />
      <Hero1 />
      <AboutUs />
      {/* <Materials /> */}
      <Footer />
    </div>
  );
};

export default Page1;
